import userManager from 'src/userManager';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import logoImage from 'src/assets/images/foreningssuport_logotype_dark_flat.png';
import { Box, Button, CssBaseline, Paper, Typography } from '@mui/material';
import { useGlobals } from 'src/shared/contexts/appContext';
import { Link, Location, useLocation } from 'react-router-dom';
import { Colors } from 'src/shared/components/styles/colors';
import { t } from 'i18next';
import { buildReturnUrl } from 'src/shared/functions/returnUrl';

export const Login = () => {
  const { cleanLocalStorage } = useGlobals();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const tenant = queryParams.get('tenant');
  const type = queryParams.get('type');

  const logoUrl = tenant ? `https://medlem.foreningssupport.se/${tenant}/custom/logo.jpg` : logoImage;

  const onLoginButtonClick = () => {
    cleanLocalStorage();

    const acrValues: string[] = [];

    if (tenant) {
      acrValues.push(`tenant:${tenant}`);
    }

    if (type) {
      acrValues.push(`type:${type}`);
    }

    // Vart besökaren var på väg innan skyddsrutinen skickade hit. Destinationen måste resa i
    // OIDC-anropets eget state, React Routers state överlever inte hoppet ut till identity.
    const from = (location.state as { from?: Location } | null)?.from;

    const args: Record<string, unknown> = {};

    if (acrValues.length > 0) {
      args.acr_values = acrValues.join(' ');
    }

    if (from) {
      args.state = { returnUrl: buildReturnUrl(from) };
    }

    userManager.signinRedirect(args);
  };

  return (
    <Box
      component='main'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100vw',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: `${Colors.PageBackground}`,
      }}
    >
      <CssBaseline />
      <Paper
        elevation={3}
        sx={{
          padding: '2rem',
          textAlign: 'center',
          maxWidth: '37.5rem',
          width: '100%',
          backgroundColor: `${Colors.White}`,
          borderRadius: '8px',
        }}
      >
        <img
          src={logoUrl}
          style={{ maxWidth: '55%', maxHeight: '80%', marginTop: '2rem', marginBottom: '2rem' }}
          alt='Logo'
          onError={(e) => {
            e.currentTarget.src = logoImage;
          }}
        />
        <Typography variant='body1' sx={{ marginBottom: '1rem', color: '#333' }}>
          {t('common:loginPrompt')}
        </Typography>
        <Button
          variant='outlined'
          size='large'
          color='primary'
          sx={{
            backgroundColor: Colors.White,
            fontSize: '1rem',
            border: '1px solid rgba(0,0,0,0.7)',
            padding: '0.7rem 1.5rem',
            '& svg': {
              marginLeft: 2,
            },
            '&:hover': {
              backgroundColor: '#d9eeff',
              border: '1px solid rgba(0,0,0,0.9)',
            },
          }}
          onClick={() => onLoginButtonClick()}
        >
          {t('common:login')}
          <ExitToAppIcon />
        </Button>
      </Paper>
      <Typography variant='body2' sx={{ marginTop: '2rem', textAlign: 'center', maxWidth: '600px' }}>
        {t('common:siteProvidedBy')}
      </Typography>
      <Typography variant='body2' sx={{ marginTop: '1rem', textAlign: 'center', maxWidth: '600px' }}>
        {t('common:supportInfo')}{' '}
        <Link target='#' to='https://hjalp.foreningssupport.se'>
          hjalp.foreningssupport.se
        </Link>
      </Typography>
    </Box>
  );
};
